// extracted by mini-css-extract-plugin
export default {"container":"DateTimeInputForm_container__d7Lji","label":"DateTimeInputForm_label__mzTbL"};